import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllListItemLabel = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-list-item-label", { ref: ref }, children));
};
export default VeltNotificationsPanelContentAllListItemLabel;
